'use client'

import { useTranslations } from 'next-intl'

import Button from '@/shared/ui/Button'

import S from '../ErrorStates.module.scss'

interface ClubProfileErrorProps {
  onRetry: () => void
}

const ClubProfileError = ({ onRetry }: ClubProfileErrorProps) => {
  const t = useTranslations('club.error')
  return (
    <div className={S.state}>
      <h2 className={S.title}>{t('title')}</h2>
      <p className={S.description}>{t('description')}</p>
      <Button color="color" onClick={onRetry}>
        {t('retry')}
      </Button>
    </div>
  )
}

export default ClubProfileError
